import StudentsList from './StudentsList';
import { StudentsListProps, StudentsListValueProps } from './types';

export type { StudentsListProps, StudentsListValueProps };
export default StudentsList;
